import React from 'react';
import { Shield } from 'lucide-react';

export function LandingFooter() {
  return (
    <footer className="bg-[#0a0e14] rounded-t-[32px] border-t border-[#44484f]/10 mt-12">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <span className="text-2xl font-headline font-bold tracking-tighter"><span className="text-[#cafd00]">Fitness</span><span className="text-[#f1f3fc]">&</span><span className="text-[#00f1fe]">me</span></span>
            <span className="text-[#a8abb3] text-sm">&copy; 2026</span>
          </div>

          <div className="flex items-center gap-6 flex-wrap justify-center">
            <a href="/blog.html" className="text-sm text-[#a8abb3] hover:text-[#cafd00] font-bold transition-colors" data-testid="footer-blog-link">Blog</a>
            <a href="/exercises.html" className="text-sm text-[#a8abb3] hover:text-[#cafd00] font-bold transition-colors" data-testid="footer-exercises-link">Exercises</a>
            <a href="/trainers.html" className="text-sm text-[#a8abb3] hover:text-[#cafd00] font-bold transition-colors" data-testid="footer-trainers-link">Trainers</a>
            <a href="/calculators.html" className="text-sm text-[#a8abb3] hover:text-[#cafd00] font-bold transition-colors" data-testid="footer-calculators-link">Calculators</a>
            <a href="/fatai.html" className="text-sm text-[#a8abb3] hover:text-[#cafd00] font-bold transition-colors" data-testid="footer-fatai-link">Fat%AI</a>
            <a href="/privacy.html" className="text-sm text-[#a8abb3] hover:text-[#f1f3fc] font-bold transition-colors" data-testid="footer-privacy-link">Privacy</a>
            <a href="/medical-disclaimer.html" className="text-sm text-[#a8abb3] hover:text-[#f1f3fc] font-bold transition-colors" data-testid="footer-disclaimer-link">Medical Disclaimer</a>
            <div className="flex items-center gap-2 px-3 py-1.5 bg-[#1b2028] rounded-full border border-[#44484f]/10">
              <Shield className="h-3.5 w-3.5 text-[#cafd00]" />
              <span className="text-[10px] text-[#a8abb3] font-bold uppercase tracking-widest">GDPR Compliant</span>
            </div>
            <a href="mailto:support@fitnessand.me" className="text-sm text-[#a8abb3] hover:text-[#f1f3fc] transition-colors">
              support@fitnessand.me
            </a>
          </div>
        </div>

        {/* SEO Keywords Footer */}
        <div className="mt-8 pt-6 border-t border-[#44484f]/10 text-center">
          <p className="text-[11px] text-[#a8abb3]/80 tracking-wider">
            All in one fitness app &bull; Gym and nutrition app &bull; Best fitness app for gym goers &bull; AI workout plan generator &bull; AI calorie counter from photo &bull; Gym tracker &bull; Find gym while traveling
          </p>
        </div>
      </div>
    </footer>
  );
}
